<template>
  <v-col class="pa-1">
    <v-card v-if="!isLoading" class="planing-livraison" color="#C8E6C9">
      <v-dialog v-model="modalData.show" width="90%" max-width="1600">
        <v-card>
          <v-col align="center" class="pa-3" style="font-weight: bold; font-size: 22px">
            Détails de livraison
          </v-col>
          <v-divider></v-divider>
          <v-col>
            <v-row>
              <v-col
                v-for="(elem, idx) in modalKeyToSHow.filter((val) =>(modalData.data[val.key] != undefined && modalData.data[val.key].length > 0) ||  val.key == 'debut_timestamp')"
                :key="idx"
                cols="12"
                md="6"
                align="left"
              >
                <v-card class="pa-2" variant="flat" style="border: solid 1px lightgrey">
                  <div style="font-size: 14px; color: grey">
                    {{ elem.text }}
                  </div>
                  <span v-if="elem.key == 'debut_timestamp'">
                    {{ formatDate(modalData.data[elem.key], "DD/MM/YYYY") }}
                  </span>
                  <!-- <span v-if="elem.key == 'poid'">
                                     {{ modalData.data[elem.key] }} poids
                  </span> -->
                  <span v-else>
                   {{ modalData.data[elem.key] }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-row>
                  <v-col
                    v-for="(stop, idx2) in JSON.parse(modalData.data.recap)"
                    :key="idx2"
                    cols="12"
                  >
                    <v-row align="center" justify="center">
                      <v-col cols="12">
                        <v-card style="border: solid 2px lightgrey" variant="flat">
                          <v-col
                            align="center"
                            style="
                              font-weight: bold;
                              font-size: 25px;
                              background-color: #fafafa;
                            "
                          >
                            <span
                              style="background-color: #d7ccc8; border-radius: 10px"
                              class="pa-2"
                            >
                              Trajet {{ idx2 + 1 }}
                            </span>
                            : {{ stop.clients[0] }}
                            <v-icon size="30" color="green"
                              >mdi-arrow-right-circle</v-icon
                            >
                            {{ stop.clients[1] }}
                          </v-col>
                          <v-divider></v-divider>
                          <v-col>
                            <v-row>
                              <v-col cols="12" style="background-color: #a5d6a7">
                                <v-col align="center">
                                  <v-chip
                                    style="
                                      background-color: white;
                                      color: black;
                                      font-weight: bold;
                                    "
                                  >
                                    À récupérer
                                  </v-chip>
                                </v-col>
                                <v-card class="pa-2" style="overflow: auto">
                                  <table
                                    v-if="
                                      stop.matriculeListeSortie &&
                                      stop.matriculeListeSortie.length > 0
                                    "
                                    style="width: 100%; border-collapse: collapse"
                                  >
                                    <tr>
                                      <th
                                        v-for="(head, idx3) in contratKeyToShow"
                                        :key="idx3"
                                      >
                                        {{ head.text }}
                                      </th>
                                    </tr>
                                    <tr
                                      v-for="(sortie, idx4) in stop.matriculeListeSortie"
                                      :key="idx4"
                                    >
                                      <td
                                        style="border: solid 1px lightgrey"
                                        v-for="(elemToShow, b) in contratKeyToShow"
                                        :key="b"
                                        align="center"
                                      >
                                        <div v-if="elemToShow.value == undefined">
                                          {{ idx4 + 1 }}
                                        </div>
                                        <div
                                          v-else-if="
                                            elemToShow.value == 'CLD_DATE_RETOUR' ||
                                            elemToShow.value == 'CLD_DATE_DEPART'
                                          "
                                        >
                                          {{
                                            formatDate(
                                              sortie[elemToShow.value],
                                              "DD/MM/YYYY"
                                            )
                                          }}
                                        </div>
                                        <div v-else>
                                          {{ sortie[elemToShow.value] }}
                                        </div>
                                      </td>
                                    </tr>
                                  </table>
                                  <div v-else style="font-weight: bold" align="center">
                                    Aucun materiel à récupérer
                                  </div>
                                </v-card>
                              </v-col>
                              <v-col cols="12" style="background-color: #9fa8da">
                                <v-col align="center">
                                  <v-chip
                                    style="
                                      background-color: white;
                                      color: black;
                                      font-weight: bold;
                                    "
                                  >
                                    À livrer
                                  </v-chip>
                                </v-col>
                                <v-card class="pa-2">
                                  <table
                                    v-if="
                                      stop.matriculeListeStock &&
                                      stop.matriculeListeStock.length > 0
                                    "
                                    style="width: 100%; border-collapse: collapse"
                                  >
                                    <tr>
                                      <th
                                        v-for="(head, idx3) in contratKeyToShow"
                                        :key="idx3"
                                      >
                                        {{ head.text }}
                                      </th>
                                    </tr>
                                    <tr
                                      v-for="(sortie, idx4) in stop.matriculeListeStock"
                                      :key="idx4"
                                    >
                                      <td
                                        style="border: solid 1px lightgrey"
                                        v-for="(elemToShow, b) in contratKeyToShow"
                                        :key="b"
                                        align="center"
                                      >
                                        <div v-if="elemToShow.value == undefined">
                                          {{ idx4 + 1 }}
                                        </div>
                                        <div
                                          v-else-if="
                                            elemToShow.value == 'CLD_DATE_RETOUR' ||
                                            elemToShow.value == 'CLD_DATE_DEPART'
                                          "
                                        >
                                          {{
                                            formatDate(
                                              sortie[elemToShow.value],
                                              "DD/MM/YYYY"
                                            )
                                          }}
                                        </div>
                                        <div v-else>
                                          {{ sortie[elemToShow.value] }}
                                        </div>
                                      </td>
                                    </tr>
                                  </table>
                                  <div v-else style="font-weight: bold" align="center">
                                    Aucun materiel à livrer
                                  </div>
                                </v-card>

                                <!-- <Vue3EasyDataTable
                                empty-message="Aucun contrat trouvé"
                                rows-per-page-message="Contrat par page"
                                :headers="contratKeyToShow"
                                :items="stop.matriculeListeStock"
                                :table-height="windowHeight * 0.7"
                              >
                              </Vue3EasyDataTable> -->
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-card>
                        <v-col
                          align="center"
                          v-if="
                            modalData.data.recap &&
                            idx2 + 1 != JSON.parse(modalData.data.recap).length
                          "
                        >
                          <v-icon color="#FF9800" size="50">mdi-arrow-down-circle</v-icon>
                        </v-col>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-card>
        <!-- <modal-materiel-state
        :data="modalData"
        @close="modalData = {}"
        @closeStatesModal="isModalsOpen['eventModal'].value = false"
      ></modal-materiel-state> -->
      </v-dialog>
      <v-dialog v-model="isModalSettingsOpen" persistent>
        <modal-settings
          :eventColorByType="eventColorByType"
          :daysToHide="daysToHide"
          @closeSettingsModal="closeSettingsModal"
        ></modal-settings>
      </v-dialog>
      <modal-chauffeur-settings
        v-if="isModalChauffeurSettingsOpen"
        :data="{ technicienList, technicienListToShow }"
        @close="isModalChauffeurSettingsOpen = false"
        @updatetechnicientsListToShow="updatetechnicientsListToShow($event)"
      >
      </modal-chauffeur-settings>
      <v-col>
        <v-row>
          <v-col>
            <v-card variant="flat">
              <v-select
                v-model="selectedPeriod"
                return-object
                :items="periodListe"
                hide-details
                label="Période"
              >
              </v-select>
            </v-card>
          </v-col>
          <v-col>
            <v-card variant="flat">
              <v-select
                label="Chauffeur"
                v-model="selectedtechToShow"
                clearable
                no-data-text="Aucun chauffeur trouvé"
                :items="getTechnicienListe"
                hide-details
              >
              </v-select>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="pt-0">
        <Vue3EasyDataTable
          :headers="tabHeader"
          :items="eventListeToShow"
          :table-height="windowHeight - 200"
          @click-row="showLivraisonData"
          rows-per-page-message="Livraison par page"
          empty-message="Aucune livraison pour les filtres sélectionnés"
        >
          <template #item-debut_timestamp="item">
            <v-col>
              {{ formatDate(item["debut_timestamp"], "DD/MM/YYYY") }}
            </v-col>
          </template>
        </Vue3EasyDataTable>
      </v-col>
    </v-card>
    <v-col v-else align="center" style="margin-top: 40vh">
      <v-progress-circular size="120" indeterminate color="black"
        >Chargement</v-progress-circular
      >
    </v-col>
  </v-col>
</template>

<script>
// import ModalLivraison from "./modal-livraison.vue";
import ModalChauffeurSettings from "./modal-settings.vue";
import { ref } from "@vue/reactivity";
import mainEngine from "@/core/index";
import engine from "../core/index";
import ModalSettings from "@/components/modal-planning-settings.vue";
import Vue3EasyDataTable from "vue3-easy-data-table";
import moment from "moment";
import { onMounted, onUnmounted, watch } from "vue";

export default {
  setup() {
    const windowHeight = ref(window.innerHeight);

    function updateHeight() {
      windowHeight.value = window.innerHeight;
    }

    onUnmounted(() => {
      window.removeEventListener("resize", updateHeight);
    });

    const periodListe = ref([
      { value: [0, 1], title: "Aujourdh'hui" },
      { value: [0, 3], title: "Sur 3 jours (à venir)" },
      { value: [0, 7], title: "Sur 7 jours (à venir)" },
      { value: [3, 3], title: "Sur ± 3 jours (passé et à venir)" },
      { value: [7, 7], title: "Sur ± 7 jours (passé et à venir)" },
    ]);

    const selectedPeriod = ref(periodListe.value[0]);

    watch(selectedPeriod, () => {
      getEvents();
    });

    const contratKeyToShow = ref([
      { value: undefined, text: "", sortable: false },
      { value: "CLD_NOM_CLIENT", text: "Client", sortable: true },
      { value: "CLD_NUM_CONTRAT", text: "Contrat", sortable: true },
      { value: "CLD_DESCRIPTION", text: "Description", sortable: true },
      { value: "CLD_MATRICULE", text: "Matricul", sortable: true },
      { value: "CLD_SOUS_FAMILLE", text: "Sous famille", sortable: true },
      { value: "CLD_DATE_DEPART", text: "Début de contrat", sortable: true },
      { value: "CLD_DATE_RETOUR", text: "Fin de contrat", sortable: true },
  //    { value: "CLD_POIDS", text: "Poids", sortable: true },
    ]);

    const modalKeyToSHow = ref([
      { text: "Descriptif", key: "nom" },
      { text: "Date de livraison", key: "debut_timestamp" },
      { text: "Durée (estimée)", key: "temps" },
      { text: "Distance (estimée)", key: "distance" },
//      { text: "Poid", key: "poid" },
      // { text: "Résumé", key: "recap" },
    ]);
    const tabHeader = ref([
      {
        text: "Chauffeur",
        value: "chauffeur",
        sortable: true,
      },
      // {
      //   text: "Nom",
      //   value: "nom",
      //   sortable: true,
      // },
      {
        text: "Date de livraison",
        value: "debut_timestamp",
        sortable: true,
      },
      {
        text: "Durée (estimée)",
        value: "temps",
        sortable: true,
      },
      {
        text: "Distance (estimée)",
        value: "distance",
        sortable: true,
      },
      // {
      //   text: "Poid",
      //   value: "poid",
      //   sortable: true,
      // },
    ]);

    const selectedtechToShow = ref(undefined);
    const isModalLivraisonOpen = ref(false);
    const isModalRecuperationOpen = ref(false);
    const isModalChauffeurSettingsOpen = ref(false);
    const modalData = ref({});
    const eventListe = ref([]);
    const technicienList = ref([]);
    const technicienListToShow = ref([]);
    // const nbrDayToShow = ref(300);

    const getEvents = function () {

      let min = parseInt(
        moment().subtract(selectedPeriod.value.value[0], "d").startOf("day").format("x")
      );
      let max = parseInt(
        moment().add(selectedPeriod.value.value[1], "d").endOf("day").format("x")
      );

      eventListe.value = [];
      engine.get_livraison(min, max, function (data) {

        if (data.code == 0) {
          let tmpEvent = [];

          for (let i = 0; i < data.data.data.length; i++) {
            let event = data.data.data[i];

            tmpEvent.push(event.fieldData);
          }
          eventListe.value = tmpEvent;
        }
      });
    };

    onMounted(() => {
      window.addEventListener("resize", updateHeight);
      getEvents();
    });

    return {
      isModalLivraisonOpen,
      isModalRecuperationOpen,
      modalData,
      eventListe,
      technicienList,
      // eventColorByType,
      technicienListToShow,
      tabHeader,
      modalKeyToSHow,
      contratKeyToShow,
      windowHeight,
      isModalChauffeurSettingsOpen,
      selectedtechToShow,
      periodListe,
      selectedPeriod,
    };
  },
  watch: {
    isModalLivraisonOpen(val) {
      if (val == false) {
        this.modalData = {};
      }
    },
  },
  mounted() {
    this.isUserConnected();
  },
  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    eventListeToShow() {

      if (this.selectedtechToShow) {
        return this.eventListe.filter((val) => val.chauffeur == this.selectedtechToShow);
      }
      return this.eventListe;
    },
    getTechnicienListe() {
      let techListe = [];

      if (this.eventListe && this.eventListe.length > 0)
        techListe = this.eventListe.map((val) => val.chauffeur);

      return [...new Set(techListe)];
    },
  },
  methods: {
    formatDate(date, format) {
      return moment(date).format(format);
    },
    showLivraisonData(data) {
      this.modalData = {
        show: true,
        data,
      };
    },
    closeSettingsModal(data) {
      let that = this;
      let days = data.daysListe.filter((val) => !data.daysToShow.includes(val.idx));
      if (days) {
        days = days.map((val) => val.idx);
        engine.save_day_to_hide(days.toString(), function () {
          that.updateCalendarDaysToShow();
        });
      }
      engine.save_calendar_colors(JSON.stringify(data.localColortab), function () {
        that.updateCalendarColors();
      });
      this.isModalSettingsOpen = false;
    },
    isUserConnected() {
      let that = this;
      let token = localStorage.getItem("userToken");
      mainEngine.get_user_by_token(token, function (data) {
        if (data.code != 0) {
          // localStorage.clear();
          localStorage.setItem("userToken", undefined);
        }
        that.isLoading = false;
      });
    },
    updatetechnicientsListToShow(techList) {
      this.technicienListToShow = techList;
    },
  },
  components: {
    Vue3EasyDataTable,
    // ModalMaterielState,
    // ModalLivraison,
    // ModalRecuperation,
    ModalChauffeurSettings,
    ModalSettings,
  },
};
</script>

<style>
@import "../style.css";
</style>
